import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewFieldSections } = formModuleLenses

export default (state, { moduleId }) => viewFieldSections(
	moduleId, moduleDescriptions,
)
